var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-invite-view"},[_c('b-container',[_c('UserInviteForm',{on:{"invite-sent":_vm.handleInviteSent,"invite-error":_vm.handleInviteError}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }